import jquery from "jquery";
window.$ = window.jQuery = jquery;
import Helpers from "../base/Helpers";


$(".js-info-banner .icon-close").on("click", function () {
    var $this = $(this);
    $this.parents(".js-info-banner").addClass("hidden");
  });
  
  $(".js-info-banner").each(function () {
    var $this = $(this);
    var trigger = $this.data("trigger");
    var hideMessageAttr = $this.data("hide-message")
    var discount = Helpers.getCookie("discount_code")
  
    if (trigger) {
      if (trigger === "discount") {
        Helpers.getDiscount().then(function (discountCode) {
          if ( discountCode ) {
            $this.find(".banner-text").html(
              $this
                .find(".banner-text")
                .text()
                .replace("{{discount_code}}", "<b>" + discountCode + "</b>")
            );
            $this.removeClass("hidden");
            setTimeout(function () {
              $this.css("opacity", "1");
            }, 1300);
          }
        });
        document.addEventListener("discount:check:url", function(e){
          const dicscountDetail = e.detail.discount_code
          if (!!dicscountDetail) {
            Helpers.getDiscount().then(function (dicscountDetail) {
              if ( dicscountDetail ) {
                $this.find(".banner-text").html(
                  $this
                    .find(".banner-text")
                    .text()
                    .replace("{{discount_code}}", "<b>" + dicscountDetail + "</b>")
                );
                $this.removeClass("hidden");
                setTimeout(function () {
                  $this.css("opacity", "1");
                }, 1300);
              }
            });
          }  
        })
      } else if (trigger === "discount-cart") {
        var discountCodeBanner = document.querySelector('.discount_code_banner')
        var savingsAmountBanner = document.querySelector('.savings_amount_banner')
        let savedAmountBanner = document.querySelector('.amount_saved_banner')
        let cartTotalSavedEl = document.querySelector('.cart-total-saved')
        let cartTotalSavedAttr = null
        let newCartTotalSavedAttr = null
        document.addEventListener('discount:check', function(e){
          if (!!e.detail) {
            var discountAmount = ''

            if (!!e.detail.discount_amount) {
              discountAmount = (e.detail.discount_amount / 100).toFixed(2).replace(/\./, ',') + ' €'
            }

            if (!!e.detail.code_valid) {
            
              if (!!discountCodeBanner) {
                discountCodeBanner.innerHTML = e.detail.discount_code
                if (!!savingsAmountBanner) {
                  savingsAmountBanner.innerHTML = discountAmount
                }
              }

              if (!!cartTotalSavedEl && !!cartTotalSavedEl.getAttribute('data-total-saved')) {
                cartTotalSavedAttr = Number(cartTotalSavedEl.getAttribute('data-total-saved'))
                cartTotalSavedAttr = (cartTotalSavedAttr / 100).toFixed(2).replace(/\./, ',') + ' €'
        
                if (!!savedAmountBanner) {
                  if (!!cartTotalSavedAttr) {
                    savedAmountBanner.innerHTML = cartTotalSavedAttr
                  }
                }
              }

              document.addEventListener('theme:loading:end', ()=>{
                fetch("/cart")
                .then( function(response) { 
                  return response.text()
                })
                .then( function(text) {
                  var parser = new DOMParser();
                  var htmlDoc = parser.parseFromString(text, "text/html");
                  var wrapperTotalSaved = htmlDoc.documentElement.querySelector(".cart-total-saved")
                  if (!!wrapperTotalSaved && !!wrapperTotalSaved.getAttribute('data-total-saved')) {
                    newCartTotalSavedAttr = Number(wrapperTotalSaved.getAttribute('data-total-saved'))
                    newCartTotalSavedAttr = (newCartTotalSavedAttr / 100).toFixed(2).replace(/\./, ',') + ' €'

                    if (newCartTotalSavedAttr !== cartTotalSavedAttr) {
                      if (!!savedAmountBanner) {
                        if (!!cartTotalSavedAttr) {
                          savedAmountBanner.innerHTML = newCartTotalSavedAttr
                        }
                      }
                    } 
                  }
                })
              })
              $this.removeClass("hidden");
              setTimeout(function () {
                $this.css("opacity", "1");
              }, 1000);

            }else {
              $this.css("opacity", "0");
              setTimeout(function () {
                $this.addClass("hidden");
              }, 1300);
            }
          }
        })
       
      } else if (trigger === "product-added") {
       var hideMessageAfter = ''

       var discountBanner = document.querySelectorAll('.info_banner-discount')
       if (!!hideMessageAttr) {
        hideMessageAfter = Number(hideMessageAttr)
       }else {
        hideMessageAfter = 3500;
       }
       var hideMessageAfterOpacity = hideMessageAfter - 200

        document.addEventListener('product:added', function(){
          $this.removeClass("hidden");
          setTimeout(function () {
            $this.css("opacity", "1");
          }, 500);

          setTimeout(function () {
            $this.css("opacity", "0");
          }, hideMessageAfterOpacity);

          setTimeout(function () {
            $this.addClass("hidden");
          }, hideMessageAfter);

          if (!!discountBanner) {
            discountBanner.forEach(function(banner){

              if (!banner.classList.contains('hidden')) {
                banner.style.opasicty = 0;
                setTimeout(function () {
                  banner.classList.add("hidden");
                }, 500);
    
                setTimeout(function () {
                  banner.classList.remove("hidden");
                }, hideMessageAfterOpacity);
    
                setTimeout(function () {
                  banner.style.opasicty= 1;
                }, hideMessageAfter);
              }
           
            })
          }
        })
      } else if (trigger === "no-discount") {
        if (!discount) {
          $this.removeClass("hidden");
          setTimeout(function () {
            $this.css("opacity", "1");
          }, 1300);
        }
        document.addEventListener("discount:check:url", function(e){
          const dicscountCodeDetail = e.detail.discount_code
          if (!!dicscountCodeDetail) {
            setTimeout(function () {
              $this.css("opacity", "0");
              $this.addClass("hidden");
            }, 1300);
          }
        })
      }
    } else {
      $this.removeClass("hidden");
      setTimeout(function () {
        $this.css("opacity", "1");
      }, 1300);
    }
});